






















































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import store from 'src/assets/store'
import ItemData from 'src/assets/ItemData'
import { ItemDataUpdate } from 'src/assets/ItemDataLive'
import PullAndScroll from 'components/PullAndScroll.vue'
import TopMenu from 'src/components/attendee/layout/TopMenu.vue'
import ItemMenu from 'components/attendee/Menu.vue'
import ActivityDashboard from 'components/presenter/layout/ActivityDashboard.vue'
import api from 'src/assets/api/gql'
import AttendeeIndex from 'src/graphql/attendee/AttendeeIndex.gql'
import AttendeeItemGet from 'src/graphql/attendee_item/AttendeeItemGet.gql'
import { AttendeeItem, ItemType, Session, ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    PullAndScroll,
    TopMenu,
    ItemMenu,
    ActivityDashboard
  }
})
export default class LayoutAttendeeItem extends Vue {
  ItemType = ItemType
  item: AttendeeItem | null = null
  top = true
  rightDrawerShowing = false

  @Ref()
  readonly viewport!: PullAndScroll

  @Ref()
  readonly subpage!: PullAndScroll

  created () {
    store.setProfile('ATTENDEE')
  }

  @Watch('$route.params.id')
  init () {
    this.viewport.refresh(() => {})
  }

  @Watch('$route.name')
  async initSubpage () {
    this.$nextTick(async () => {
      await this.subpage.refresh(() => {})
      this.reload()
    })
  }

  reload () {
    this.$nextTick(() => {
      this.viewport.loader.resume()
      this.viewport.loader.poll()
    })
  }

  async refresh (done: () => void) {
    const { data: { attendeeItem } } = await api.query({
      query: AttendeeItemGet,
      variables: {
        id: +this.$route.params.id,
        personId: store.state.person.id
      }
    })
    if (attendeeItem) {
      attendeeItem.data = new ItemData((attendeeItem.data as ItemDataUpdate))
      attendeeItem.presenters = attendeeItem.presenters?.nodes || []
      this.item = attendeeItem
      this.$nextTick(async () => {
        await this.subpage.refresh(done)
      })
    } else {
      this.$router.replace('/attendee/')
    }
  }

  async load (index: number, done: (stop?: boolean) => void) {
    await this.subpage.load(index, done)
  }

  async activityLoad () {
    const { data: { attendeeComingSessions: { nodes: sessions }, attendeeForumTopicsRecent: { nodes: forumTopics } } } = await api.query({
      query: AttendeeIndex,
      variables: {
        days: 7,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        first: 10
      }
    })
    return { sessions, forumTopics }
  }

  activitySessionUrl (session: Session) {
    return session.topic ? `/attendee/${session.topic.id}/session/${session.id}` : '/attendee/'
  }

  activityForumTopicUrl (forumTopic: ForumTopic) {
    return `/attendee/${forumTopic.courseId}/forum/${forumTopic.id}`
  }
}
